<template>
  <VDialog v-model="dialog" width="600px">
    <VCard>
      <VBtn
        absolute
        icon
        right
        style="right: 0"
        class="mt-0 pb-0"
        @click="close"
      >
        <VIcon>mdi-close</VIcon>
      </VBtn>
      <VCardTitle class="text-center red--text">{{
        $t("notCompatible")
      }}</VCardTitle>
      <VCardSubtitle class="mt-0 pb-0">{{
        $t(`attachPhotosAndComment`)
      }}</VCardSubtitle>
      <VCardText>
        <ValidationObserver v-slot="{ handleSubmit }" ref="formObs">
          <form @submit.prevent="handleSubmit(send)">
            <div class="py-2">
              <CustomTextTextarea
                :label="$t('enterText')"
                class="user_input"
                v-model="description"
              ></CustomTextTextarea>
            </div>
            <!--            <ValidationProvider-->
            <!--              tag="div"-->
            <!--              class="py-2"-->
            <!--              :name="$t('file')"-->
            <!--              rules="required|document"-->
            <!--              v-slot="{ errors }"-->
            <!--            >-->
            <!--              <VFileInput-->
            <!--                v-model="files"-->
            <!--                :error-messages="errors[0]"-->
            <!--                :label="$t('uploadPhoto') + '*'"-->
            <!--              ></VFileInput>-->
            <!--            </ValidationProvider>-->
            <div class="text-right">
              <VBtn type="submit" color="primary">{{ $t("send") }}</VBtn>
            </div>
          </form>
        </ValidationObserver>
      </VCardText>
    </VCard>
  </VDialog>
</template>

<script>
export default {
  data() {
    return {
      dialog: false,
      contractItemId: null,
      files: [],
      description: null,
    };
  },
  watch: {
    dialog(val) {
      if (!val) this.clear();
    },
  },
  methods: {
    clear() {
      this.description = null;
      this.files = null;
      this.$refs.formObs.reset();
    },
    async send() {
      this.showLoading();
      try {
        const formData = new FormData();
        // formData.append("accept", "0");
        formData.append("itemId", this.contractItemId);
        formData.append("rejectReason", this.description);
        // formData.append("files", this.files);

        await this.$http.post("/contract/office/reject/omtk", formData);
        this.$emit("updateTableData");
        this.setSuccess({ text: this.$t("successfullySent") });
        this.close();
      } catch (e) {
        this.setResponseError({ error: e });
      } finally {
        this.clearLoading();
      }
    },
    open(contractItemId) {
      this.contractItemId = contractItemId;
      this.dialog = true;
    },
    close() {
      this.dialog = false;
    },
  },
};
</script>
